
import {Component, Vue} from 'vue-property-decorator';
import {IExternalData} from '@/interfaces/external-data';
import {arrDifference, arrSymmetricDifference, rules} from '@/utils';
import {
  dispatchExternalDataFileUpload,
  dispatchGetFormsAdmin,
  dispatchRegisterFormValuesInBatchAdmin,
} from '@/store/admin/actions';
import {readAdminForms} from '@/store/admin/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import {IFormValues} from '@/interfaces/form';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
import AlertDialogWrapper from '@/components/dialogs/AlertDialogWrapper.vue';
import AlertDialogFrame from '@/components/dialogs/AlertDialogFrame.vue';
import {readExternalData} from '@/store/main/getters';

@Component({
  components: {AlertDialogFrame, AlertDialogWrapper, DynamicTable, DefaultHelp},
})
export default class CRUDExternalData extends Vue {
  private CEDTitle: string = `${this.$t('crud.register')} ${this.$t('forms_in_batch')}`;
  private csvFile: any = null;
  private objectHeaders: any = [];
  private objectValues: any = [];
  private valid: boolean = true;
  private rules: any = rules;
  private formID: number = -1;
  private selectedItem: any = null;
  private form: any = null;
  private alertDialog: any = null;
  private alertHeader: string = '';
  private alertMessage: string = '';

  private sourceField: string = '';

  private formValues: IFormValues[] = [] as IFormValues[];

  private externalData: IExternalData = {} as IExternalData;

  private get forms() {
    return readAdminForms(this.$store);
  }

  private get isDisabled() {
    return !(!!this.selectedItem && !!this.sourceField);
  }

  public async mounted() {
    this.form = this.$refs.form_crud_ed;
    this.formID = this.$router.currentRoute.params.id as unknown as number;
    if (!this.forms) {
      await dispatchGetFormsAdmin(this.$store);
    }

    this.formValues = [] as IFormValues[];
    this.formID = 0;
    this.alertDialog = this.$refs.alert_dialog;

  }

  public beforeRouteLeave(to, from, next) {
    this.externalData = {} as IExternalData;
    this.CEDTitle = `${this.$t('crud.create')} ${this.$t('external_data')}`;
    this.formID = 0;
    this.csvFile = null;
    this.objectHeaders = [];
    this.objectValues = [];
    next();
  }

  private async saveData() {
    if (await this.form.validate()) {
      if (await dispatchRegisterFormValuesInBatchAdmin(this.$store, this.formValues)) {
        await this.$router.push({name: 'main-admin-forms-list'});
      }
    }
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    this.form.reset();
  }

  private async loadFileInTable(val) {
    this.externalData.headers = [];
    this.externalData.values = [];
    this.objectHeaders = [];
    // this.objectValues = [];
    if (!this.csvFile) {
      console.log('No file selected');
      return;
    }

    if (await dispatchExternalDataFileUpload(this.$store, this.csvFile)) {
      this.externalData = readExternalData(this.$store) as IExternalData;
      if (this.externalData?.headers) {
        this.externalData.headers.forEach((item) => {
          this.objectHeaders.push({text: item, align: 'start', sortable: false, value: item});
        });
        let formHeaders = this.selectedItem?.form_setting?.form_data?.controls;

        (this.externalData.values || []).forEach((e) => {
          this.formValues.push({
            form_id: this.selectedItem.id,
            version: this.selectedItem.version,
            form_values: e,
            external_source: this.sourceField,
          } as IFormValues);
        });

        formHeaders = Object.values(formHeaders).map((item: any) => item.name ? item.name : item.uniqueId);
        const arr1 = JSON.parse(JSON.stringify(formHeaders));
        const arr2 = JSON.parse(JSON.stringify(this.externalData.headers));

        const difference = arrSymmetricDifference(arr1, arr2);

        if (difference) {
          this.alertHeader = 'Atenção!';
          this.alertMessage = `O seu arquivo possui alguns campos diferentes do formulário selecionado:<br/>
                             Campos do formulário: <pre class="text-break">${JSON.stringify(arrDifference(arr1, arr2))}</pre><br/>
                             Campos do arquivo: <pre class="text-break">${JSON.stringify(arrDifference(arr2, arr1))}</pre><br/>
                             Deseja continuar?`;
          const resp = await this.alertDialog.open({width: 600}).then((result) => {
            return result;
          });
          if (!resp) {
            this.csvFile = null;
            this.externalData = {} as IExternalData;
            return;
          }
        }
      }
    }
  }


}
